// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const resetUpdateShowApplyTravel = () => getClaimDefaultState().updateShowApplyTravel;

const updateUpdateShowApplyTravel = (state, action) => action.updateShowApplyTravel;

export default (state = getClaimDefaultState().updateShowApplyTravel, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_NORMAL_UPDATE_SHOW_APPLY_TRAVEL]: updateUpdateShowApplyTravel,
        [actions.RESET_CLAIM_NORMAL]: resetUpdateShowApplyTravel
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/normal/reducers/update-show-apply-travel.js